module.exports = __webpack_public_path__ + "static/img/fgq_big.69915a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/fgq_big.png
// module id = hB3a
// module chunks = 18